module.exports = __webpack_public_path__ + "static/img/素材延展.e649342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/素材延展.png
// module id = k50J
// module chunks = 1